import CircularProgress from '@jimmyboys/liita-ui/dist/components/CircularProgress'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import moment from 'moment'
import { Link, useParams } from 'react-router-dom'

import styles from './widgets.module.sass'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import useSession from 'hooks/useSession'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

const renderExpertiseDisabilities = (expertises, i18n) => {
	return expertises.map(({ expertise, disabilities }, index) => {
		return disabilities.length ? (
			<VStack
				key={`inner_${index}`}
				className={styles['expertise-disability-entry']}
				gap='small'
			>
				<h5 className={styles['group-title']}>{expertise}</h5>
				{disabilities.map(
					({ rate, name, startDate, endDate, daysCount }, idx) => (
						<HStack
							key={`inner_${idx}`}
							className={styles['disability-entry']}
							gap='small'
							align='center'
						>
							<div
								className={
									styles['circular-progress-container']
								}
							>
								<CircularProgress size={20} progress={rate} />
								<small
									className={
										styles['circular-progress-percentage']
									}
								>
									{rate}
								</small>
								<small>%</small>
							</div>
							<div>
								<h5>{name}</h5>
								<small>
									{startDate?.shortDateFormat} -{' '}
									{endDate?.shortDateFormat || ''} (
									{daysCount} {i18n`day`}
									{daysCount !== 1 && 's'})
								</small>
							</div>
						</HStack>
					)
				)}
			</VStack>
		) : null
	})
}

const ClinicalEpisodeFromToDate = (props) => {
	const { from, to } = props

	return (
		<small>
			({from.shortDateFormat} - {to.shortDateFormat})
		</small>
	)
}

const DisabilityRate = (props) => {
	const { rate } = props
	const { i18n } = useGlobal()

	return (
		<div className={styles['disability-rate']}>
			<small>
				<strong>{rate.rate}</strong> ({rate.disabilityId}) -{' '}
				{rate.count} {i18n`day`}
				{rate.count !== 1 && 's'}
			</small>
		</div>
	)
}

const getTodayDisability = (disabilities) => {
	const todayDate = moment().format('YYYY-MM-DD')

	const disability = (disabilities ?? []).reduce((acc, cur) => {
		if (cur && cur.byDays && cur.byDays[todayDate]) {
			const value = cur.byDays[todayDate]?.split('-')
			acc = `${value[0]}% (${value[1]})`
			return acc
		}

		return acc
	}, undefined)

	return disability
}

const DisabilitiesWidget = (props) => {
	const { data } = props
	const { disabilities } = data
	const { i18n } = useGlobal()
	const todaysDisability = getTodayDisability(disabilities)
	const params = useParams()
	const processId = params.clinicalProcessId
	const { user } = useSession()

	const isAdmin = user?.roles?.some((role) => role.toLowerCase() === 'admin')

	const hasDisabilities =
		disabilities &&
		disabilities.length &&
		Object.keys(disabilities[0].byDays).length

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			icon='disabled'
			title={i18n`Disabilities`}
			expanded={!!hasDisabilities}
			expandable={!!hasDisabilities}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			<div className={styles['today-disability-rate']}>
				<small>
					<strong>{i18n`Current disability`}: </strong>{' '}
					{todaysDisability ??
						i18n`Without data to determine disability.`}
				</small>
			</div>
			<VStack gap='small'>
				{disabilities?.map((disability, idx) => (
					<VStack key={`clinical_episode_${idx}`}>
						<div className={styles['clinical-episode-title']}>
							<strong>{i18n`Clinical episode`}</strong>{' '}
							<ClinicalEpisodeFromToDate
								from={disability.startDate}
								to={disability.endDate}
							/>
						</div>
						<div>
							{disability.byRate.map((disabilityRate) => (
								<DisabilityRate
									key={disabilityRate.disabilityId}
									rate={disabilityRate}
								/>
							))}
						</div>
						{renderExpertiseDisabilities(
							disability.byExpertise ?? [],
							i18n
						)}
					</VStack>
				))}
				{/*{isAdmin && (*/}
				<HStack justify='flex-end'>
					<Link
						to={`/clinical-processes/${processId}/disabilities`}
						className={styles['check-disabilities']}
					>
						<Icon name='branch' width='20px' height='20px' />
						{i18n`Check`}
					</Link>
				</HStack>
				{/*)}*/}
			</VStack>
		</ExpandableWidget>
	)
}

export default DisabilitiesWidget
